import { IconType, SvgIcon } from './SvgIcon';

export const MinusIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      d="M15.833 9.16602H4.16634C3.94533 9.16602 3.73337 9.25381 3.57709 9.41009C3.42081 9.56637 3.33301 9.77833 3.33301 9.99935C3.33301 10.2204 3.42081 10.4323 3.57709 10.5886C3.73337 10.7449 3.94533 10.8327 4.16634 10.8327H15.833C16.054 10.8327 16.266 10.7449 16.4223 10.5886C16.5785 10.4323 16.6663 10.2204 16.6663 9.99935C16.6663 9.77833 16.5785 9.56637 16.4223 9.41009C16.266 9.25381 16.054 9.16602 15.833 9.16602Z"
      fill="currentColor"
    />
  </SvgIcon>
);

MinusIcon.displayName = 'MinusIcon';
